/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.35
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ChecklistPeriodDTO model module.
 * @module model/ChecklistPeriodDTO
 * @version v0
 */
export class ChecklistPeriodDTO {
  /**
   * Constructs a new <code>ChecklistPeriodDTO</code>.
   * @alias module:model/ChecklistPeriodDTO
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ChecklistPeriodDTO</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChecklistPeriodDTO} obj Optional instance to populate.
   * @return {module:model/ChecklistPeriodDTO} The populated <code>ChecklistPeriodDTO</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ChecklistPeriodDTO();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'Number');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
    }
    return obj;
  }
}

/**
 * @member {Number} id
 */
ChecklistPeriodDTO.prototype.id = undefined;

/**
 * @member {String} name
 */
ChecklistPeriodDTO.prototype.name = undefined;

